import { ScrollTrigger } from '../gsap/setup';

export function initBrand() {
  if (document.body.classList.contains('no-color-change')) return;

  const $block = $('.brand');
  if (!$block.length) return;

  ScrollTrigger.create({
    trigger: $block[0],
    start: 'top center',
    end: 'bottom center',
    onEnter: () => {
      document.body.classList.add('is-dark');
    },
    onLeaveBack: () => {
      document.body.classList.remove('is-dark');
    },
  });
}
